import MemberSpendingQueries from './MemberSpendingQueries'

const mvMemberSpending = {
  mvMemberSpending: {
    ...MemberSpendingQueries,
  }
}

export default mvMemberSpending